import { Component, OnInit } from '@angular/core';
import { Company } from '../../../../models/company';
import { Location } from '../../../../models/location';
import { CompanyService } from '../../../../services/company.service';
import { LocationService } from '../../../../services/location.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Audit_Log } from '../../../../models/audit_log';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-location-manage',
  templateUrl: './location-manage.component.html',
  styleUrls: ['./location-manage.component.css']
})
export class LocationManageComponent implements OnInit {
  companies: Company[];
  location: Location;
  client;

  constructor(private companyService: CompanyService, authService: AuthService, private locationService: LocationService, private router: Router, private route: ActivatedRoute) {
    this.client = authService.currentUser.value;
    this.location = new Location();
  }

  ngOnInit() {
    this.companyService.getAll(0).then((data) => {
      this.companies = data;
      this.route.queryParams.subscribe(params => {
        const location_Id = params['location_Id'];
        if (location_Id != undefined) {
          this.locationService.get(location_Id).then((data) => {
            this.location = data;
            this.location.audit_Log = new Audit_Log();
            this.location.is_edit = true;
          });
        }
      });
    });
  }

  submit() {

    this.location.audit_Log.entity = this.location.audit_Log.auditTypes.Locations;
    this.location.audit_Log.entity_Id = this.location.location_Id;

    this.location.audit_Log.user_Id = this.client.userId;
    this.location.audit_Log.description = this.client.firstname + " " + this.client.lastname;

    if (this.location.is_edit) {
      this.location.audit_Log.actionType = this.location.audit_Log.actionTypes.UPDATE;
    }
    else {
      this.location.audit_Log.actionType = this.location.audit_Log.actionTypes.INSERT;
    }

    this.locationService.save(this.location).then((data) => {
      this.router.navigate(['administration/location_management']);
    });
  }


}
